import { useLocation } from "react-router-dom";
import './topBackground.scss';
import React from "react";
import utils from "../../../module/utils";
import line from "../../Home/img/line.svg"

/**
 * 位于顶部的背景组件
 */
export default function TopBackground(props){

    const location = useLocation();

    const showBackgroundPath = ["/help", "/contact"]

    return (
        <React.Fragment>
            {utils.contain(showBackgroundPath, location.pathname) &&
            <div className="top-background-wrap" >
                <img src={line} className="bg-line" />
            </div>}
        </React.Fragment>
    );
};